import React, { Component } from 'react'
import styled from 'styled-components'
import IcClose from './images/ic-close.component.svg'

export default class MobileModalV2 extends Component {
  componentDidMount() {
    this.sendModalOpen()
  }

  componentWillUnmount() {
    this.sendModalHide()
    this.props.setModalTriggerHeight(null)
  }

  sendModalHide = () => {
    const { modalTriggerHeight } = this.props
    window.parent.postMessage(
      { type: 'sendModalMobileHide', height: modalTriggerHeight },
      '*'
    )
  }

  sendModalOpen = () => {
    window.parent.postMessage(
      { type: 'sendModalMobileOpen', payload: true },
      '*'
    )
  }

  render() {
    const {
      title,
      onClose,
      children,
      border,
      logo,
      scrollable,
      ...restProps
    } = this.props

    return (
      <WrapperBg onMouseDown={onClose}>
        <Wrapper {...restProps} onMouseDown={(e) => e.stopPropagation()}>
          <TitleRow border={border}>
            {logo && <img className='logo' src={logo} alt={title} />}
            <h1>{title}</h1>
            <span>
              <IcClose onClick={onClose} />
            </span>
          </TitleRow>
          <Content scrollable>{children}</Content>
        </Wrapper>
      </WrapperBg>
    )
  }
}

const WrapperBg = styled.div`
  background-color: #25272ca3;
  position: fixed;
  inset: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100dvw;
  height: 100dvh;
  background: #fff;

  position: absolute;
  top: 0;
  max-height: 800px;
`

const TitleRow = styled.div`
  display: flex;
  padding: 12px 20px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  align-self: stretch;

  ${({ border }) => border && 'border-bottom: 1px solid #ECECEC;'}

  > .logo {
    width: 30px;
    height: 30px;
    object-fit: contain;
  }

  h1 {
    color: #010101;
    font-family: Nunito;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px; /* 140% */
    text-transform: uppercase;
    margin: 0;
    flex: 1 0 0;
  }

  span {
    cursor: pointer;
  }
`

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  flex: 1 0 0;

  ${({ scrollable }) =>
    scrollable &&
    `
    overflow: scroll;
  `}
`



// WEBPACK FOOTER //
// ./src/components/MobileModalV2/index.js